module.exports = __webpack_public_path__ + "static/media/tmc.5bbe5aae.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/social-proof/tmc.svg
// module id = 2090
// module chunks = 0